import { BoxContainer } from '@components/common';
import { Button, Typography } from '@components/base';
import css from './index.module.scss';
import { sanitizeValue } from '@helpers/utils';
import { get, SECTIONS } from '../../helper';
import {
  commodityInfo,
  customerOrderInformation,
  FieldDef,
  InstructionAndChargesFormValues,
  ShipmentDetailsFormValues
} from '../../bol';

interface IProps {
  onFormSubmit: () => Promise<void>;
  handleCancelClick: () => void;
  commodityInformation: commodityInfo[] | null;
  customerOrderInformation: customerOrderInformation | null;
  secondForm: InstructionAndChargesFormValues;
  firstForm: ShipmentDetailsFormValues;
}

const BillOfLadingPreview = (props: IProps) => {
  const { onFormSubmit, handleCancelClick } = props;
  return (
    <div className={css.container}>
      <BoxContainer title="Preview" className={css.mainWrapper}>
        {SECTIONS.map(({ title, fields }) => (
          <div key={title} className={css.boxWrapper}>
            <Typography variant="h5">{title}</Typography>
            {fields
              .reduce<FieldDef[][]>((rows, f, i) => {
                if (i % 3 === 0) rows.push([]);
                rows[rows.length - 1].push(f);
                return rows;
              }, [])
              .map((row, idx) => (
                <div key={idx} className={css.rowWrapper}>
                  {row.map((f) => {
                    const raw = get(props, f.path);
                    const value = f.render ? f.render(raw, props) : raw ?? '—';
                    return (
                      <div key={f.path} className={css.keyValue}>
                        <Typography variant="ptext">{f.label}</Typography>
                        <Typography variant="pdoc">{sanitizeValue(value)}</Typography>
                      </div>
                    );
                  })}
                </div>
              ))}
          </div>
        ))}

        <div className={css.boxWrapper}>
          <Typography variant="h5">Commodity Information</Typography>
          {Array.isArray(props.commodityInformation) &&
            props.commodityInformation.map((c: any, i: any) => (
              <div key={i} className={css.rowWrapper}>
                <div className={css.keyValue}>
                  <Typography variant="ptext">Product</Typography>
                  <Typography variant="pdoc">{c.productName}</Typography>
                </div>
                <div className={css.keyValue}>
                  <Typography variant="ptext">Package Count</Typography>
                  <Typography variant="pdoc">{c.packageCount}</Typography>
                </div>
                <div className={css.keyValue}>
                  <Typography variant="ptext">Description</Typography>
                  <Typography variant="pdoc">{c.packageDescription}</Typography>
                </div>
                <div className={css.keyValue}>
                  <Typography variant="ptext">Net Weight</Typography>
                  <Typography variant="pdoc">{c.netWeight}</Typography>
                </div>
              </div>
            ))}
        </div>
      </BoxContainer>
      <div className={css.formActionWrapper}>
        <Button variant="text" onClick={handleCancelClick}>
          Cancel
        </Button>
        <Button type="submit" onClick={() => onFormSubmit()}>
          Save and Proceed
        </Button>
      </div>
    </div>
  );
};

export default BillOfLadingPreview;
